<template>
  <div v-if="styleType === 'normal'">
    <input
    class="rp-input is-small"
    v-bind:class="{ 'is-danger': status }"
    type="text"
    v-bind:placeholder="inputData.placeholder"
    v-bind:value="value"
    v-bind:maxlength="inputData.limit"
    v-on:input="updateValue($event.target.value)"
    v-on:blur="validateInput()">

    <div class="validation-text" v-if="status === true">
      {{ errorMessage }}
    </div>
  </div>
  <div v-else-if="styleType === 'material'" class="rp-material-form-input">
    <label class="rp-material-form-label">
      <input
        class="rp-material-input is-small"
        :class="{ 'is-danger': status }"
        type="text"
        v-bind:value="value"
        v-bind:maxlength="inputData.limit"
        v-bind:placeholder="inputData.placeholder"
        v-on:input="updateValue($event.target.value)"
        v-on:blur="validateInput()"
        required>
      <span class="rp-material-input-placeholder">{{ inputData.label }}</span>
    </label>
    <div class="validation-text" v-if="status === true">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'TextInput',
  props: {
    value: String,
    styleType: {
      type: String,
      default: 'normal'
    },
    inputData: {
      type: Object,
      default: () => {
        return {
          id: 1,
          type: 'text',
          required: '0',
          placeholder: 'placeholder',
          limit: 100,
          option: [],
          label: ''
        }
      }
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          pleaseInsertEmail: 'Please insert a valid email ',
          pleaseInsertPhone: 'Please insert a valid phone number',
          pleaseInsertText: 'Please insert data',
          pleaseInsertLimitedText: `Please insert data not exceed ${this.inputData.limit} characters`
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          pleaseInsertEmail: 'กรุณากรอกอีเมลให้ถูกต้อง',
          pleaseInsertPhone: 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง',
          pleaseInsertText: 'กรุณากรอกข้อมูล',
          pleaseInsertLimitedText: `กรุณากรอกข้อมูลไม่เกิน ${this.inputData.limit} ตัวอักษร`
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          pleaseInsertEmail: 'Vui lòng nhập email hợp lệ',
          pleaseInsertPhone: 'Vui lòng nhập số điện thoại hợp lệ',
          pleaseInsertText: 'Vui lòng nhập dữ liệu',
          pleaseInsertLimitedText: `Vui lòng nhập dữ liệu không quá ${this.inputData.limit} kí tự`
        }
      }
    }
  },
  data () {
    return {
      status: false,
      errorMessage: ''
    }
  },
  methods: {
    validateInput () {
      let result = true
      let regexEmail = new RegExp(Cart.regex.validation.email)
      let regexPhone = new RegExp(Cart.regex.validation.phone)

      this.errorMessage = ''

      if (this.value === '' && this.inputData.required === '1') {
        this.status = true
        result = false

        if (this.inputData.type === 'email') {
          this.errorMessage = this.t.pleaseInsertEmail
        } else if (this.inputData.type === 'tel') {
          this.errorMessage = this.t.pleaseInsertPhone
        } else {
          this.errorMessage = this.t.pleaseInsertText
        }

        return result
      } else {
        this.status = false
      }

      if (this.inputData.type === 'text') {
        if (this.value.length > this.inputData.limit) {
          result = false
          this.status = true
          this.errorMessage = this.t.pleaseInsertLimitedText
        }
      }

      if (this.inputData.type === 'email') {
        if (!regexEmail.test(this.value) && this.value !== '') {
          result = false
          this.status = true
          this.errorMessage = this.t.pleaseInsertEmail
        } else {
          result = true
          this.status = false
        }

        if (result === true && this.value.length > this.inputData.limit) {
          result = false
          this.status = true
          this.errorMessage = this.t.pleaseInsertLimitedText
        }
      }

      if (this.inputData.type === 'tel') {
        if (!regexPhone.test(this.value) && this.value !== '') {
          result = false
          this.status = true
          this.errorMessage = this.t.pleaseInsertPhone
        } else {
          result = true
          this.status = false
        }
      }

      return result
    },
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.validation-text {
  color: red;
  font-size: 0.75em;
}

.rp-material-form-input {
  .rp-material-form-label {
    .rp-material-input {
      border-bottom: 1px dashed #eee;
      border-bottom-width: 1px !important;
      top: 0px;

      &::placeholder {
        color: #bbb;
      }

      &:valid:not(:focus) {
        border-bottom: 1px dashed #eee;
      }

      &:focus {
        border-bottom: 1px solid rgb(33, 150, 243);
      }
    }

    .rp-material-input-placeholder {
      display: none;
    }
  }

  .validation-text {
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/TextInput.vue